function useMessage() {
  const message = 'Olá, Gostaria de desenvolver um software.';
  const encodedMessage = encodeURI(message);
  window.open(
    `https://api.whatsapp.com/send/?phone=+5563991072312&text=${encodedMessage}`,
  );
}

export default useMessage;
